import { state } from '@/core/store/auth/state';
import { getters } from '@/core/store/auth/getters';
import { mutations } from '@/core/store/auth/mutations';
import { actions } from '@/core/store/auth/action';

export const auth = {
    state,
    getters,
    actions,
    mutations,
};
